'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('e-form-browser', {
      url: '/e-form/data-browser/:id',
      template: '<e-form-browser></e-form-browser>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/e-form/browser/e-form-browser.routes.js